import { autoinject } from "aurelia-framework";
import { CollaboratorEmail, DueDiligenceClientModel, DueDiligenceRequestModel, GetCollaboratorsResponse, GetDueDiligenceRiskScores, GetLastDueDiligenceResponse, GetRiskAnalysisRulesRequest, GetRiskAnalysisRulesResponse, SaveDueDiligenceResponse, VetRecentActivityClientModel, VetRuleRunClientModel, VetRuleRunItemClientModel, VetRuleRunRiskClientModel, VetStatusEnum } from "../models/due-diligence.models";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { CloneHelper } from "@rightship-tech/common-ui/helpers/clone.helper";

@autoinject
export class DueDiligenceApi {

    private dueDiligenceApiUrl: string = `${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/DueDiligence`;

    constructor(private requestClient:RequestClientService, private configService: ConfigService) {}

	getDueDiligence(id: number, includeVetTasks: boolean): Promise<DueDiligenceClientModel> {
        return this.requestClient.get(`${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/DueDiligence/GetDueDiligence/${id}`, { includeVetTasks }).then((response: any) => {
            const dueDiligence = CloneHelper.clone(response) as DueDiligenceClientModel;
            return <DueDiligenceClientModel>{
                ...dueDiligence,
                vetStatus: response.status,
                vetStatusId: response.statusId,
                vetStatusHistory: response.statusHistory,
                vetStatusHistoryId: response.statusHistoryId,
                vetTasks: response.vetTasks
            }
        });
	}

	saveDueDiligence(manualDischargePort: boolean, manualLoadPort: boolean, dischargePortCountryId: number,
        loadPortCountryId: number, dischargePort: string, loadPort: string, vet: DueDiligenceRequestModel,
        collaboratorEmails: string[], complianceEmails: string[]): Promise<SaveDueDiligenceResponse> {
        return this.requestClient.post(`${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/DueDiligence/SaveDueDiligence`, {}, 
            {
                collaboratorEmails: collaboratorEmails,
                complianceCheckEmails: complianceEmails,
                manualDischargePort: manualDischargePort,
                manualLoadPort: manualLoadPort,
                dischargePortCountryId: dischargePortCountryId,
                loadPortCountryId: loadPortCountryId,
                dischargePort: dischargePort,
                loadPort: loadPort,
                vet: vet
            }
        );
	}

    getLastDueDiligence(vesselId: number): Promise<GetLastDueDiligenceResponse> {
        return this.requestClient.get(`${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/DueDiligence/GetLastDueDiligence/${vesselId}`, { })
            .then((response: GetLastDueDiligenceResponse) => {
                response.lastDueDiligence = Object.assign(new DueDiligenceClientModel(), response.lastDueDiligence);
                return response;
            });
    }

    getDueDiligenceRuleRunsClientModel(id: number): Promise<VetRuleRunClientModel[]> {
        return this.requestClient.get(`${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/DueDiligence/GetDueDiligenceRuleRunsClientModel/${id}`, {});
    }

    getDueDiligenceRuleRunItemRiskClientModel(vetId: number, vettingRuleRunId: number): Promise<VetRuleRunRiskClientModel[]>  {
        return this.requestClient.get(`${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/DueDiligence/GetDueDiligenceRuleRunItemRiskClientModel/${vetId}`, { vettingRuleRunId });
    }

    getDueDiligenceRuleRunItemsClientModel(vetId: number, vettingRuleRunId: number, previousVettingRuleRunId: number): Promise<VetRuleRunItemClientModel[]> {  
        return this.requestClient.get(`${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/DueDiligence/GetDueDiligenceRuleRunItemsClientModel/${vetId}`, { vettingRuleRunId, previousVettingRuleRunId });
    }

    generateRecentLink(vetId: number, title: string, id: number, type: string) {
        const titleFormatted = title ? title.toLowerCase() : null;
        const typeFormatted = type ? type.toLowerCase() : null;

        if (typeFormatted == 'rfi') {
            return `due-diligence/${vetId}?subtaskId=${id}`;
        }
        else if (titleFormatted == 'tq' || titleFormatted == 'moc' || titleFormatted == 'class status' || titleFormatted == 'hq' || titleFormatted == 'vessel application form' || typeFormatted == 'class-status') {
            return `/vet-task-onboarding-custom-content?vesselApplicationFormId=${id}`;
        }
        else if (titleFormatted == 'inc') {
            return `/incident/${id}`
        }
        else if (titleFormatted == 'environmental verification') {
            return `/environmental-review-request/${id}`
        }
        return `/${titleFormatted}/${id}`;
    }

    isLink(type: string) {
        // if (type?.toLowerCase() == 'psc') {
        //     return this.userClaimsService.hasPermission(Claims.CanAccessPSCs);
        // } else if (type?.toLowerCase() == 'inc') {
        //     return this.userClaimsService.hasPermission(Claims.CanAccessINCs);
        // } else if (type?.toLowerCase() == 'insp') {
        //     return this.userClaimsService.hasPermission(Claims.CanAccessRightShipInspections);
        // } else if (type?.toLowerCase() == 'ghg') {
        //     return this.userClaimsService.hasPermission(Claims.CanAccessEnvironmentals);
        // } else if (type?.toLowerCase() == 'tvq') {
        //     return this.userClaimsService.hasPermission(Claims.CanAccessForms);
        // } else if (type?.toLowerCase() == 'rfi') {
        //     return this.userClaimsService.hasPermission(Claims.RightShipUser);
        // } else if (type?.toLowerCase() == 'cfr') {
        //     return this.userClaimsService.hasPermission(Claims.CanAccessCFRs);
        // }

        return true;
    }

    getVetRecentActivity(vetId: any, onlyOpen: boolean, hideInsp: boolean, hideRfis:boolean, unHideSubtaskSourceId?:number): Promise<VetRecentActivityClientModel[]> {
        return this.requestClient.get<VetRecentActivityClientModel[]>(`${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/DueDiligence/RecentActivity/${vetId}`, {});
    }

    //Change status
    public changeStatus(vetId: number, message: string, statusSnippet: string, status: VetStatusEnum): Promise<void> {
        return this.requestClient.post(`${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/DueDiligence/ChangeStatus`, {}, 
            {
                id: vetId,
                message: message,
                statusSnippet: statusSnippet,
                statusId: status
            });
    }
    
    //Get collaborators
    public getCollaborators(vetId: number): Promise<GetCollaboratorsResponse> {
        return this.requestClient.get<GetCollaboratorsResponse>(`${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/Manage/GetCollaborators`, {
            vetId: vetId
        });
    }
    
    //Get risk scores
    public getRiskScores(vetId: number): Promise<GetDueDiligenceRiskScores> {
        return this.requestClient.get<GetDueDiligenceRiskScores>(`${this.dueDiligenceApiUrl}/GetRiskScores/${vetId}`, {});
    }

    //Save collaborators
    public saveCollaborators(vetId: number, collaboratorEmails: CollaboratorEmail[]): Promise<void> {
        return this.requestClient.post<void>(`${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/Manage/SaveCollaborators`, {},{
            vetId: vetId,
            collaborators: collaboratorEmails
        });
    }

    //Get risk analysis rules
    public getRiskAnalysisRules(request: GetRiskAnalysisRulesRequest): Promise<GetRiskAnalysisRulesResponse> {
        return this.requestClient.post(`${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/PortsAndTerminals/GetRiskAnalysisRules`, {}, request);
    }

    //Re-run rules
    public rerunRules(vetId: number): Promise<void> {
        return this.requestClient.post(`${this.dueDiligenceApiUrl}/ReRunRules/${vetId}`, {}, {});
    }
    
    public getSharedAccessSignatureTokenFromPath(url: string, fileName:string): Promise<string> {
        return this.requestClient.get(`${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/RightShipAttachment/GetSharedAccessSignatureTokenFromPath`, { url, fileName });
    }
}
